import React, { useReducer } from 'react';
import * as T from '@dayetopia/types';

export const initialState: CheckoutState = {
  shippingAddress: undefined,
  coupon: undefined
};

interface Context {
  checkoutState: CheckoutState;
  checkoutDispatch(a: ActionTypes): void;
}

const mockDispatch = (a: ActionTypes) => {
  console.debug(a);
};

const initial: Context = {
  checkoutState: initialState,
  checkoutDispatch: mockDispatch
};

const CheckoutContext = React.createContext(initial);

function reducer(state: CheckoutState, action: ActionTypes): CheckoutState {
  switch (action.type) {
    case 'setShippingAddressInCheckout':
      return {
        ...state,
        shippingAddress: action.data
      };
    case 'setCoupon':
      return {
        ...state,
        coupon: action.data
      };
    default:
      throw new Error(JSON.stringify(action, null, 2));
  }
}

interface Props {
  children: React.ReactNode;
}

function CheckoutProvider({ children }: Props) {
  const [checkoutState, checkoutDispatch] = useReducer(reducer, initialState);

  return (
    <CheckoutContext.Provider
      value={{
        checkoutState,
        checkoutDispatch
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
}

export interface CheckoutState {
  shippingAddress?: T.ShippingAddress;
  coupon?: any;
}

interface SetShippingAddressInCheckout {
  type: 'setShippingAddressInCheckout';
  data: T.ShippingAddress;
}

interface SetCoupon {
  type: 'setCoupon';
  data: any;
}

type ActionTypes = SetShippingAddressInCheckout | SetCoupon;

export { CheckoutContext, CheckoutProvider };
